// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentsLogsWrapper__vvL3v {
  border: 1px solid var(--header-stroke);
  border-top: unset;
  padding: 15px;
  background: var(--tables-secondary-row-sub-title-surface);
}

.equipmentsLogsTableWrapper__uItdU {
  position: relative;
  max-height: 350px;
  overflow: auto;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
}
.equipmentsLogsTableWrapper__uItdU::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.equipmentsLogsTableWrapper__uItdU::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.equipmentsLogsTableWrapper__uItdU::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.equipmentsLogsTableWrapper__uItdU::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.equipmentLogsTable__jC6wV {
  width: 100%;
}
.equipmentLogsTable__jC6wV th {
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  text-align: left;
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  position: sticky;
  top: 0;
}
.equipmentLogsTable__jC6wV th .infoIcon__J6Mx7 {
  outline: none;
  margin-bottom: -3px;
  margin-left: 5px;
}
@media (max-width: 1280px) {
  .equipmentLogsTable__jC6wV th {
    font-size: 10px;
  }
}
@media (max-width: 900px) {
  .equipmentLogsTable__jC6wV th {
    font-size: 9px;
  }
}
.equipmentLogsTable__jC6wV td {
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
}
@media (max-width: 1280px) {
  .equipmentLogsTable__jC6wV td {
    font-size: 12px;
  }
}
@media (max-width: 1024px) {
  .equipmentLogsTable__jC6wV td {
    font-size: 11px;
  }
}
@media (max-width: 900px) {
  .equipmentLogsTable__jC6wV td {
    font-size: 10px;
  }
}

.equipmentLogsTableBodyRow__dmch1:hover {
  background: var(--tables-primary-row-surface-hover);
}

.uppercaseCell__uYWJY {
  text-transform: uppercase;
}

.messageCell__jrOit {
  max-width: 350px;
}

.skeletonRow__QEyDX td {
  padding-top: 16px;
  padding-bottom: 15px;
}

.skeletonText__ZyUpm {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageEquipment/components/TableEquipmentsLog/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,sCAAA;EACA,iBAAA;EACA,aAAA;EACA,yDAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;AAaE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAXJ;AAcE;EACE,+BAAA;EACA,kBAAA;AAZJ;AAeE;EACE,8BAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,kBAAA;AAdJ;;AA6DA;EACE,WAAA;AA1DF;AA4DE;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,MAAA;AA1DJ;AA4DI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA1DN;AA6DI;EApBF;IAqBI,eAAA;EA1DJ;AACF;AA4DI;EAxBF;IAyBI,cAAA;EAzDJ;AACF;AA4DE;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yDAAA;EACA,mBAAA;AA1DJ;AA4DI;EAVF;IAWI,eAAA;EAzDJ;AACF;AA2DI;EAdF;IAeI,eAAA;EAxDJ;AACF;AA0DI;EAlBF;IAmBI,eAAA;EAvDJ;AACF;;AA4DE;EACE,mDAAA;AAzDJ;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,gBAAA;AA1DF;;AA8DE;EACE,iBAAA;EACA,oBAAA;AA3DJ;;AA+DA;EACE,YAAA;AA5DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentsLogsWrapper {\n  border: 1px solid var(--header-stroke);\n  border-top: unset;\n  padding: 15px;\n  background: var(--tables-secondary-row-sub-title-surface);\n}\n\n.equipmentsLogsTableWrapper {\n  position: relative;\n  max-height: 350px;\n  overflow: auto;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n\n  @include scrollBar;\n}\n\n.equipmentLogsTable {\n  width: 100%;\n\n  th {\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    text-align: left;\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    position: sticky;\n    top: 0;\n\n    .infoIcon {\n      outline: none;\n      margin-bottom: -3px;\n      margin-left: 5px;\n    }\n    \n    @media (max-width: 1280px) {\n      font-size: 10px;\n    }\n\n    @media (max-width: 900px) {\n      font-size: 9px;\n    }\n  }\n\n  td {\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n\n    @media (max-width: 1280px) {\n      font-size: 12px;\n    }\n\n    @media (max-width: 1024px) {\n      font-size: 11px;\n    }\n\n    @media (max-width: 900px) {\n      font-size: 10px;\n    }\n  }\n}\n\n.equipmentLogsTableBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.uppercaseCell {\n  text-transform: uppercase;\n}\n\n.messageCell {\n  max-width: 350px;\n}\n\n.skeletonRow {\n  td {\n    padding-top: 16px;\n    padding-bottom: 15px;\n  }\n}\n\n.skeletonText {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentsLogsWrapper": `equipmentsLogsWrapper__vvL3v`,
	"equipmentsLogsTableWrapper": `equipmentsLogsTableWrapper__uItdU`,
	"equipmentLogsTable": `equipmentLogsTable__jC6wV`,
	"infoIcon": `infoIcon__J6Mx7`,
	"equipmentLogsTableBodyRow": `equipmentLogsTableBodyRow__dmch1`,
	"uppercaseCell": `uppercaseCell__uYWJY`,
	"messageCell": `messageCell__jrOit`,
	"skeletonRow": `skeletonRow__QEyDX`,
	"skeletonText": `skeletonText__ZyUpm`
};
module.exports = ___CSS_LOADER_EXPORT___;
